import React, { useMemo } from 'react';
import { isFeatureEnabledForCurrentTenant } from '@warehouse/shared/config';
import { OptionalInherited } from '@nexspec/warehouse-shared-types/src/titles/TitleMetadata/Inherited';
import CustomMetadataBase, { CustomMetadataColumn } from '../localizedInfo/CustomMetadata';
import useTitleAutoSave from '../../../hooks/useTitleAutoSave/useTitleAutoSave';
import { fromBasic } from '../../../../../utils/titleGetProperty';

export function BasicCustomMetadata() {
	const drmAutoSave = useTitleAutoSave<OptionalInherited<boolean>>({
		label: 'Custom metadata DRM',
		path: useMemo(() => fromBasic(['terms', 'DRM']), []),
	});

	const materialStatusAutoSave = useTitleAutoSave<OptionalInherited<string>>({
		label: 'Custom metadata material status',
		path: useMemo(() => fromBasic(['terms', 'materialStatus']), []),
	});

	const data = useMemo<CustomMetadataColumn[]>(() => {
		const rows: CustomMetadataColumn[] = [];
		if (isFeatureEnabledForCurrentTenant('custom-field-basic-DRM')) {
			const value = drmAutoSave.readOnlyValue?.displayValue;
			rows.push({
				name: 'DRM',
				value: value == null ? '' : value.toString(),
				type: 'boolean',
				autoSave: drmAutoSave,
			});
		}

		if (isFeatureEnabledForCurrentTenant('custom-field-basic-materialStatus')) {
			rows.push({
				name: 'Material Status',
				value: materialStatusAutoSave?.readOnlyValue?.displayValue || '',
				type: 'string',
				autoSave: materialStatusAutoSave,
			});
		}
		return rows;
	}, [drmAutoSave, materialStatusAutoSave]);

	return <CustomMetadataBase data={data} />;
}
